export const MAX_DATABASE_ITEM_LAYOUT_VIEW_COUNT = 500
